module.exports = __webpack_public_path__ + "img/arrow-down-blue.e5394e30.svg";